import React, { useState } from 'react';

import DomainTable from '../../components/domainTable.js'
import WebsiteSecondaryPageTitle from '../../components/websiteSecondaryPageTitle.js'

import {SubdomainsPageResult} from '../../../../server/routes/website.js'

interface WebsiteSubdomainsOptions {
    server: string,
    pageData: unknown
}

export default function WebsiteSubdomains({ server, pageData }: WebsiteSubdomainsOptions) {

	let [data, setData] = useState(pageData as SubdomainsPageResult);

    // TODO: all that code below is the same for /website/* pages ... create a component out of it
    return (<>
        <WebsiteSecondaryPageTitle domainPageHeader={data.DomainPageHeader}/>
        <section className="section section-sm">
            <div className="container">
                <DomainTable 
                    domainList={data.DomainList}
                />    
            </div>
        </section>
    </>)
}
